import { Link as RouterLink } from 'react-router-dom';
import { s } from '@/theme/tokens';
import { Stack } from '@/ui';
import { Box, Button, Link, Text } from '@/ui/primitives';
import { landingSpacing } from './landingSpacing';
import { LANDING_BODY_FONT_SIZE } from './landingTypography';
import type { ReactElement } from 'react';

type EarlyAccessSectionProps = {
  width: number;
};

export const EarlyAccessSection = ({ width }: EarlyAccessSectionProps): ReactElement => (
  <Box
    component="section"
    id="request-early-access"
    sx={(theme) => ({
      position: 'relative',
      left: '50%',
      right: '50%',
      width: '100vw',
      ml: '-50vw',
      mr: '-50vw',
      pt: landingSpacing.earlyAccess.outerPaddingTop,
      pb: s('none'),
      background: `linear-gradient(120deg, ${theme.app.colors.surfaceAlt} 0%, ${theme.app.colors.surface} 46%, ${theme.app.colors.primary}12 70%, ${theme.app.colors.surfaceAlt} 85%, ${theme.app.colors.surface} 100%)`,
    })}
  >
    <Box
      sx={{
        width: '100%',
        maxWidth: `${width}px`,
        mx: 'auto',
        pt: landingSpacing.earlyAccess.innerPaddingTop,
        pb: landingSpacing.earlyAccess.innerPaddingBottom,
        px: `calc(${s('lg')} + ${s('lg')})`,
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: landingSpacing.earlyAccess.columnsGap,
          width: '100%',
        }}
      >
        <Stack gap="md" sx={{ maxWidth: { xs: '100%', md: '48ch' } }}>
          <Text role="sectionTitle" component="h2" transform="none">
            Ready To Get More From Your Results?
          </Text>
          <Text role="bodyMuted" component="p" sx={{ fontSize: LANDING_BODY_FONT_SIZE }}>
            Sign up for a sprint and see how FlowQA can help your quality and testing workflows. No
            payment details required.
          </Text>
          <Box sx={{ pt: s('sm') }}>
            <Button variant="primary" component={RouterLink} to="/sign-up">
              Sign Up For Free
            </Button>
          </Box>
        </Stack>
        <Stack gap="md" sx={{ maxWidth: { xs: '100%', md: '48ch' } }}>
          <Text role="sectionTitle" component="h2" transform="none">
            Need More Information?
          </Text>
          <Text role="bodyMuted" component="p" sx={{ fontSize: LANDING_BODY_FONT_SIZE }}>
            If you'd like to know more, would like an introductory walkthrough, or to talk about
            your unique test and quality issues, drop us a friendly email at{' '}
            <Link href="mailto:support@flowqa.com" underline="none">
              support@flowqa.com
            </Link>{' '}
            and we'll get back to you.
          </Text>
        </Stack>
      </Box>
    </Box>
  </Box>
);
